@if (contentEdit) {
  <div class="expand-box-edit">
    @if (item) {
      <coin-v2-text-input
        [label]="'cms.content-pages.headline-text' | translate"
        [placeholder]="'cms.content-pages.headline-text' | translate"
        [(ngModel)]="item.headline" />
    }
    <coin-v2-text-input
      [label]="'cms.content-pages.icon' | translate"
      [placeholder]="'cms.content-pages.icon' | translate"
      [(ngModel)]="item.icon" />
  </div>
}

<div class="expand-box-main">
  <div
    class="expand-box-item"
    (click)="boxExpanded = !boxExpanded">
    <div class="expand-box-item-content">
      @if (item?.icon) {
        <span class="material-icons-outlined">{{ item?.icon }}</span>
      }
      <p>{{ item?.headline }}</p>
      <span class="material-icons-outlined">expand_more</span>
    </div>
  </div>
  <div
    class="expand-box-content"
    [ngClass]="{ 'expand-box-content--expanded': boxExpanded || contentEdit }">
    @if (!contentEdit) {
      <div [innerHTML]="item?.text | pure: cutOutNbsp"></div>
    }
    @if (contentEdit) {
      <coin-html-editor
        [item]="item"
        [contentEdit]="true"
        [isNews]="true"></coin-html-editor>
    }
  </div>
</div>
